import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Button, CloseIcon } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import { FilterIcon } from '@root/shared/ui-kit'

import { ExploreFilterCount } from './explore-filter-count'

import type { ExploreFiltersAtom } from '../../atoms'

type Props = {
  model: ExploreFiltersAtom
  onOpenChange?: (open: boolean) => void
}

export const ExploreFilterHeader: React.FC<Props> = ({
  model,
  onOpenChange,
}) => {
  const { t } = useTranslation()

  const [appliedFiltersCount] = useAtom(model.appliedFiltersCount)

  return (
    <Root>
      <Title $isActive={!!appliedFiltersCount}>
        <FilterIcon size={16} />
        {t('common.filter')}
        {appliedFiltersCount ? (
          <ExploreFilterCount fontSize={10} count={appliedFiltersCount} />
        ) : undefined}
      </Title>
      <Button
        variant="ghost"
        type="button"
        iconLeft={<CloseIcon />}
        onClick={() => onOpenChange?.(false)}
        size="xs"
      />
    </Root>
  )
}

const Root = styled.div`
  border-bottom: 1px solid var(--background-3);

  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;

  padding: 10px;
`

const Title = styled.div<{ $isActive: boolean }>`
  color: ${(props) => (props.$isActive ? 'var(--text-12)' : 'var(--text-11)')};

  display: flex;
  /* grid-template-columns: auto 1fr; */
  align-items: center;

  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`
